/**
 * @file routes.jsx
 * @description Definisi semua route aplikasi.
 * Menggunakan React.lazy untuk code-splitting otomatis per halaman.
 */
import React from 'react';

const Layout1         = React.lazy(() => import('../pages/Layout1/Layout1'));
const DetailKomoditas = React.lazy(() => import('../pages/DetailKomoditas/DetailKomoditas'));
const DetailArtikel   = React.lazy(() => import('../pages/DetailArtikel/DetailArtikel'));
const DesaCantik      = React.lazy(() => import('../pages/DesaCantik/DesaCantikWrapper'));
const DetailGaleri    = React.lazy(() => import('../pages/DetailGaleri/DetailGaleri'));
const DetailFasilitas = React.lazy(() => import('../pages/DetailFasilitas/DetailFasilitas'));
const SemuaBerita     = React.lazy(() => import('../pages/SemuaBerita/SemuaBerita'));

/**
 * @typedef {Object} RouteConfig
 * @property {string} path - URL path
 * @property {React.LazyExoticComponent} component - Komponen halaman
 * @property {boolean} [exact] - Apakah path harus exact match
 */

/** @type {RouteConfig[]} */
const routes = [
  { path: '/DetailKomoditas/:id', component: DetailKomoditas },
  { path: '/DetailGaleri/:id',   component: DetailGaleri    },
  { path: '/DetailFasilitas/:id',component: DetailFasilitas },
  { path: '/DetailArtikel/:id',  component: DetailArtikel   },
  { path: '/semua-berita',       component: SemuaBerita     },
  { path: '/DesaCantik',         component: DesaCantik      },
  { path: '/',                   component: Layout1         },
];

export default routes;
